module.exports = {"420981001":"城中街道","420981002":"城北街道","420981003":"四里棚街道","420981004":"东马坊街道","420981005":"长江埠街道","420981100":"田店镇","420981101":"杨河镇","420981102":"三合镇","420981103":"郎君镇","420981104":"黄滩镇","420981105":"天鹅镇","420981106":"义和镇","420981107":"陈河镇","420981108":"杨岭镇","420981109":"汤池镇","420981400":"经济技术开发区","420981500":"南垸良种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420981.json
// module id = 1610
// module chunks = 0